import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import TypographyMarked from 'components/TypographyMarked/TypographyMarked';
import { formatDataTestId, generateTestId } from 'utils/general';

const CustomChip = ({
  backgroundColor,
  chipId,
  color,
  icon,
  iconPosition = 'right',
  isPrint = false,
  label,
  searchContextValues,
}) => (
  <Stack
    backgroundColor={backgroundColor}
    color={color}
    direction="row"
    alignItems="center"
    py="0.25rem"
    px="0.5rem"
    borderRadius="0.25rem"
    spacing="0.5rem"
    maxHeight="1.5rem"
    textTransform="uppercase"
    overflow="visible"
    display="inline-flex"
  >
    {iconPosition === 'left' && <Stack>{icon}</Stack>}
    <TypographyMarked
      dataTestId={generateTestId(
        'VehicleRecord',
        'TransportationStatusChip',
        isPrint ? null : formatDataTestId(chipId),
      )}
      variant={isPrint ? 'print1' : 'label1'}
      component="span"
      color={color}
      value={label}
      fieldId={`${label}-${chipId}`}
      isPrint={isPrint}
      searchContextValues={searchContextValues}
    />
    {iconPosition === 'right' && <Stack>{icon}</Stack>}
  </Stack>
);

CustomChip.propTypes = {
  backgroundColor: PropTypes.string,
  chipId: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.string,
  isMobile: PropTypes.bool,
  isPrint: PropTypes.bool,
  label: PropTypes.string.isRequired,
  searchContextValues: PropTypes.object,
};

export default CustomChip;
